import { makeAutoObservable, runInAction } from 'mobx';
import { io, Socket } from 'socket.io-client';
import { chatApi, API_AUTH_URL } from 'api';

class ChatStore {
  unreadCount = 0;
  private socket: Socket | null = null;

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  async fetchUnreadCount() {
    try {
      const { count } = await chatApi.getUnreadCount();
      runInAction(() => { this.unreadCount = count; });
    } catch {
      // ignore
    }
  }

  connectSocket(_userId: string) {
    if (this.socket?.connected) return;

    // Бэкенд валидирует JWT в handshake; userId извлекается из payload.
    const accessToken = localStorage.getItem('accessToken');
    if (!accessToken) return;

    this.socket = io(`${API_AUTH_URL}/`, {
      transports: ['websocket'],
      auth: { token: accessToken },
    });

    this.socket.on('chat:unreadCountChanged', ({ count }: { count: number }) => {
      runInAction(() => { this.unreadCount = count; });
    });
  }

  disconnectSocket() {
    this.socket?.disconnect();
    this.socket = null;
  }
}

export const chatStore = new ChatStore();
